<script setup lang="ts">

import { AppText } from '@shared/ui/typography'
import { ModalDefault } from '@shared/ui/modals'
import { AppDatePicker } from '@shared/ui/fields'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import DisciplineScheduleSelector from '../DisciplineScheduleSelector.vue'
import { useModalDisciplineScheduleEffectiveDate } from '../../model/modal-discipline-schedule-effective-date.hook'

defineOptions({
  name: 'ModalDisciplineScheduleEffectiveDate',
})

const {
  modeOptions,
  refMode,
  refIsNow,
  refEffectiveDate,
  refMinDate,
  refIsDisabled,
  setMode,
  setEffectiveDate,
  close,
  back,
  confirm,
} = useModalDisciplineScheduleEffectiveDate()
</script>

<template>
  <ModalDefault
    show
    title="Choose start date for changes"
    class-name="modal-discipline-schedule-step"
    is-close-button
    is-back-button
    @click:overlay="close"
    @click:close="close"
    @click:back="back"
  >
    <div class="modal-discipline-schedule-effective-date">
      <AppText
        name="body2"
        color="slate-900"
        class="modal-discipline-schedule-effective-date__info"
      >
        📎 Select “Start now” to update all upcoming lessons at once, or “From specific date” to pick a start
        date—lessons from that date will follow the new schedule, and lessons before it will stay the same.
      </AppText>
      <div class="modal-discipline-schedule-effective-date__modes">
        <DisciplineScheduleSelector
          v-for="option in modeOptions"
          :key="option.mode"
          :text="option.text"
          :selected="option.mode === refMode"
          @click="setMode(option.mode)"
        />
      </div>
      <AppDatePicker
        label="Specify the start date"
        placeholder="Select here"
        :value="refEffectiveDate"
        :min-date="refMinDate"
        :disabled="refIsNow"
        @change="setEffectiveDate"
      />
    </div>
    <template #controls>
      <BtnPrimary
        text="Continue"
        color="emerald"
        :disabled="refIsDisabled"
        @click="confirm"
      />
      <BtnSecondary
        text="Cancel"
        color="black"
        @click="close"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalDisciplineSchedule.scss" />
<style scoped lang="scss" src="./ModalDisciplineScheduleEffectiveDate.scss" />
